'use strict';

var _require = require('./constant'),
    SHARE_TYPE = _require.SHARE_TYPE;

var share = require('./share');
var getShareContent = require('./get_share_content');
module.exports = {
  share: share,
  SHARE_TYPE: SHARE_TYPE,
  getShareContent: getShareContent
};